<template>
  <div class="about-pc">
    <h2>麦克风检测</h2>
    <tab :active=3></tab>
    <div v-if="recordEvent === info.ready ||recordEvent === info.recording">
      <p class="tip top-tip">请点击 <span>麦克风按钮</span> 大声读出下面一段话，完成麦克风检测：</p>
      <p class="dialog">“麦克风测试”</p>
    </div>
    <p v-if="recordEvent === info.finish || recordEvent === info.end" class="play-tip">请点击 <span>播放按钮，</span>检测录音：</p>
    <p v-if="recordEvent === info.play" class="play-no-txt"></p>
    <div class="audio-wrap">
      <span v-if="recordEvent === info.ready || recordEvent === info.finish || recordEvent === info.end" class="wave"></span>
      <img v-else class="moire" src="https://dev-cdn-common.codemao.cn/dev/27/public-edu/5/moire/moire.gif" alt="">
      <div class="func-wrap">
        <span v-if="recordEvent === info.ready" class="microphone microphone-hover" @click="startAudio"></span>
        <span v-else-if="recordEvent === info.recording || recordEvent === info.play" class="stop" @click="stopAudio"></span>
        <span v-else-if="recordEvent === info.finish || recordEvent === info.error || recordEvent === info.end"
              class="play microphone-hover"
              @click="playAudio"></span>
      </div>
      <span v-if="recordEvent === info.ready || recordEvent === info.finish || recordEvent === info.end" class="wave"></span>
      <img v-else class="moire" src="https://dev-cdn-common.codemao.cn/dev/27/public-edu/5/moire/moire.gif" alt="">
      <span class="masking"></span>
    </div>
    <audio ref="audioDom" @ended="finishAudio" v-show="false" controls playsinline :src="audioSrc"></audio>
    <p class="tip" v-if="recordEvent === info.recording">正在录制
      <span class="error time-num">{{num}}</span><span class="error time">s</span>
    </p>
    <p class="tip" v-else-if="recordEvent === info.play">正在播放</p>
    <p class="tip error" v-else-if="recordEvent === info.error">麦克风录制异常</p>
    <ul id="recordingslist"></ul>
    <div class="btn-wrap">
      <span class="restart-btn" v-if="recordEvent === info.finish || recordEvent === info.error || recordEvent === info.play" @click="setInfo('h')">听不到</span>
      <span class="sure-btn" v-if="recordEvent === info.finish || recordEvent === info.play" @click="setInfo('i')">听得到</span>
    </div>
  </div>
</template>

<script>
import Tab from './Tab'
import RecordRTC from 'recordrtc'
export default {
  components: {
    Tab
  },
  data () {
    return {
      recorderRTC: '', // rtc对象
      stream: null, // 录制的流对象
      audioContext: '',
      recordEvent: 0, // 录制事件
      microphone: '',
      num: 5, // 读秒
      info: {
        ready: 0, // 准备中
        recording: 1, // 录制中
        play: 2, // 播放中
        error: 3, // 异常
        end: 4, // 录制结束
        finish: 5 // 完成
      },
      audioSrc: '' // 录音的链接
    }
  },
  mounted() {
    // this.init()
    // 音频节点
    this.audioContext = new AudioContext()
  },
  methods: {
    // 初始化
    countdown () {
      // if (this.recordEvent !== this.info.recording) return
      this.timer = setInterval(() => {
        this.num -= 1
        if (this.num === 0) {
          clearInterval(this.timer)
          this.stopAudio()
        }
      }, 1000)
    },
    async init () {
      this.recorderRTC = ''
      this.stream = null
      if (!navigator.mediaDevices.getUserMedia) {
        // this.$emit('setMicroInfo', 'a')
        return
      }
      const contrains = {
        audio: {
          sampleRate: 48000,
          channelCount: 1,
          echoCancellation: false
        }
      }
      try {
        this.stream = await navigator.mediaDevices.getUserMedia(contrains)
      } catch (error) {
        this.handleError(error)
      }
    },
    async startAudio () {
      this.recorderRTC = ''
      this.stream = null
      if (!navigator.mediaDevices.getUserMedia) {
        this.$emit('setMicroInfo', 'a')
        return
      }
      const contrains = {
        audio: {
          sampleRate: 48000,
          channelCount: 1,
          echoCancellation: false
        }
      }
      // 加倒计时
      this.countdown()
      try {
        this.stream = await navigator.mediaDevices.getUserMedia(contrains)
        this.recorderRTC = new RecordRTC(this.stream, {
          type: 'audio'
        })
        // 开始录制
        this.recorderRTC.startRecording()
        this.recordEvent = this.info.recording
      } catch (error) {
        this.handleError(error)
      }
    },
    stopAudio () {
      // 录制时
      if (this.recordEvent === this.info.recording) {
        this.recorderRTC.stopRecording(this.stopRecordingCallback)
        // 关闭
        this.stream.stop()
        this.stream = null
        // this.recordEvent = this.info.end
      }
      // 播放时
      // if (this.recordEvent === this.info.play) {
      //   console.log(this.$refs.audioDom.paused)
      //   if (this.$refs.audioDom.paused) {
      //     this.recordEvent = this.info.play
      //     this.$refs.audioDom.currentTime = 0
      //     this.$refs.audioDom.play()
      //   } else {
      //     this.recordEvent = this.info.finish
      //     this.$refs.audioDom.pause()
      //   }
      // }
    },
    playAudio () {
      this.recordEvent = this.info.play
      this.$refs.audioDom.play()
    },
    // 完成后
    finishAudio () {
      this.recordEvent = this.info.finish
    },
    handleError (error) {
      let error_tip = error.message
      switch (error.name) {
        case 'NotAllowedError':
          error_tip = 'b'
          break
        case 'OverConstrainedError':
          error_tip = 'c'
          break
        case 'NotFoundError':
          error_tip = 'd'
          break
        case 'NotReadableError':
          error_tip = 'e'
          break
        case 'AbortError':
          error_tip = 'f'
          break
        default:
          error_tip = 'g'
          break
      }
      this.$emit('setMicroInfo', error_tip)
    },
    stopRecordingCallback () {
      this.replaceAudio(URL.createObjectURL(this.recorderRTC.getBlob()))
      // TODO:硬加的 就特么这样吧
      setTimeout(() => {
        this.playAudio()
      }, 100)
    },
    replaceAudio (src) {
      if (src) {
        this.audioSrc = src
      }
    },
    setInfo(val) {
      this.$emit('setMicroInfo', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.tip {
  color: #333;
  font-size: 16px;
}
.play-tip {
  margin: 90px auto -17px;
  font-weight: 400;
  color: #333;
  span {
    font-size: 18px;
    font-weight: 500;
  }
}
.play-no-txt {
  margin: 148px auto -17px;
}
.error {
  color: #FF5030;
  font-weight: 300;
}
.time-num {
  font-weight: 500;
}
.time {
  margin-left: 2px;
  font-weight: 400;
}
.sure-btn {
  margin-left: 60px;
  @include theme-fill-btn(144px, 42px, 16px, 4px);
}
.restart-btn {
  @include theme-empty-btn(144px, 42px, 16px, 4px);
}
.top-tip {
  margin: 34px 0 12px;
  font-weight: 400;
  color: #333;
  span {
    font-size: 18px;
    font-weight: 500;
  }
}
.dialog {
  position: relative;
  width: 260px;
  margin: auto;
  height: 30px;
  line-height: 30px;
  background: #00C882;
  border-radius: 18px;
  color: #fff;
  font-size: 14px;
  font-weight: 300;
  &::after {
    content: '';
    position: absolute;
    border: 7px solid transparent;
    border-bottom: 9px solid #00C882;
    top: -14px;
    right: 30px;
  }
}
.audio-wrap {
  display: flex;
  position: relative;
  align-items: center;
  margin: 34px auto 7px;
  width: 292px;
  height: 98px;
  &:hover .microphone-hover, &:hover .stop {
    transform: scale(.9)
  }
  // background: url('~@/assets/images/detect/audio.png') no-repeat center / cover;
}
.masking {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 95px;
  height: 95px;
  border-radius: 50%;
  background: rgba(48, 145, 255, 0.1);
}
.moire {
  width: 79px;
  height: 54px;
  // background: #000;
}
.wave {
  width: 79px;
  height: 54px;
  background: url('~@/assets/images/detect/wave.png') no-repeat center / cover;
}
.func-wrap {
  position: relative;
  width: 72px;
  height: 72px;
  display: flex;
  justify-content: center;
  background: linear-gradient(270deg,rgba(59,141,255,1) 0%,rgba(48,111,255,1) 100%);
  box-shadow: 0px 4px 10px 0px rgba(48,111,255,0.41);
  align-items: center;
  margin: auto;
  z-index: 2;
  border-radius: 50%;
  span {
    cursor: pointer;
    width: 95px;
    height: 95px;
  }
  .microphone {
    background: url('~@/assets/images/detect/microphone.png') no-repeat center / 28px 37px;
  }
  .play {
    background: url('~@/assets/images/detect/play.png') no-repeat 26px 33px / 26px 30px;
  }
  .stop {
    background: url('~@/assets/images/detect/stop.png') no-repeat center / 20px 29px;
  }
}
.btn-wrap {
  display: flex;
  justify-content: center;
  margin: 33px 0 50px;
}
</style>
